import projectImagesSelectComponent from './project-images-select.component';

const projectImagesSelectModule = angular.module('projectImagesSelect', [
])
  .component('projectImagesSelect', projectImagesSelectComponent)
  .name;

export default projectImagesSelectModule;
